import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { WeathermapFacade } from '@store/weathermap.facade';
import moment from 'moment-timezone';

@Component({
  selector: 'app-banner',
  imports: [TextModule, IconModule, PipesModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);

  selectedStation = this.weathermapFacade.selectedStation;

  state: 'opened' | 'closed';

  bannerLink =
    'https://www.netatmo.com/offers-blackfriday?utm_source=weathermap&utm_medium=referral&utm_content=weathermap_banner&utm_campaign=Black+Friday+Deals&utm_id=Black+Friday+Deals';

  isDisplayed(): boolean {
    return moment().isBefore('2025-12-01');
  }
}
